<template>
  <LabelselectTime
  :value-format="valueFormat"
  :format="format"
  v-bind="$attrs"
  v-on="$listeners"
  :label="label"
  @focus="selectTime"
  >
</LabelselectTime>
</template>


<script>
import LabelselectTime from "@/components/label-input-v2/time-select/index"
  export default {
    props: {
        label: {
            Type: String,
            default: ''
        },
        valueFormat: {
            type: String,
            required: false,
            default: "timestamp",
        },
        format: {
            type: String,
            required: false,
            default: "HH:mm",
        },
    },
    methods: {
        selectTime() {
            this.$nextTick(()=>{
                [...document.querySelectorAll('.time-select-item')].forEach(item => {
                    item.style = 'padding: 12px 24px;color:#000;;font-size: 14px;font-weight: 500 !important;'
                });
                [...document.querySelectorAll('.disabled')].forEach(item => {
                    item.style = 'padding: 12px 24px;font-size: 14px;font-weight: 500 !important;color:#E4E7ED;'
                })
                
            })
        }
    },
    components: {LabelselectTime}
  }
</script>

<style scoped lang='scss'>
    /deep/  .el-icon-time::before {
        display: block;
        height: 16px;
        width: 16px;
        content: url('../images/icon-16-drop-down.svg');
        transform: translateY(2px) translateX(4px);
    } 
    /deep/ .is-disabled .el-icon-time::before {
        display: block;
        height: 16px;
        width: 16px;
        content: url('../images/Incative.svg');
        transform: translateY(4px) translateX(4px);
    }
    /deep/ .el-input__suffix .el-input__suffix-inner .el-input__icon{ 
        display: none;
    }
    /deep/ .popper__arrow {
        display: none;
    }
</style>
